import { render, staticRenderFns } from "./MaintenanceFleetDetail.vue?vue&type=template&id=b684026c&scoped=true"
import script from "./MaintenanceFleetDetail.vue?vue&type=script&lang=js"
export * from "./MaintenanceFleetDetail.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceFleetDetail.vue?vue&type=style&index=0&id=b684026c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b684026c",
  null
  
)

export default component.exports